export default "__VITE_ASSET__DsrrPyob__"